export const ApproximateTxnsMapper = (resp) => {
    if (resp.data)
        return {
            editSplitOriginalTransaction: resp.data.editSplitOriginalTransaction.map((x) => {
                return Object.assign(Object.assign({}, x), { editable: x.filterFlags.editable });
            }),
        };
    return {
        editSplitOriginalTransaction: [],
    };
};
